import { ContextHolder } from "@frontegg/react";

export const logout = ({ returnTo }: {returnTo?: string}) => {
    const { baseUrl } = ContextHolder.getContext();
    window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${encodeURIComponent(returnTo || window.location.origin)}`;
};
